'use client';

import { useState } from 'react';
import styles from './FaqShort.module.scss';
import { IconChevronUp, IconPlus } from '@tabler/icons-react';

export interface FaqItem {
  question: string;
  answer: string;
}

export interface FaqShortProps {
  badge?: string;
  title?: string;
  subtitle?: string;
  items: FaqItem[];
}

export function FaqShort({ badge, title, subtitle, items }: FaqShortProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className={styles.section} aria-labelledby="faq-short-title">
      <div className={styles.container}>
        <div className={styles.header}>
          {badge && <span className={styles.badge}>{badge}</span>}
          {title && (
            <h2 id="faq-short-title" className={styles.title}>
              {title}
            </h2>
          )}
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        <div className={styles.list}>
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={index} className={`${styles.item} ${isOpen ? styles.open : ''}`}>
                <button
                  className={styles.question}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                >
                  <span>{item.question}</span>
                  <span className={styles.icon} aria-hidden="true">
                    {isOpen ? <IconChevronUp size={18} /> : <IconPlus size={18} />}
                  </span>
                </button>
                <div className={styles.answer} hidden={!isOpen}>
                  <p>{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
